var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pallet.products.length > 0)?_c('canvas',{attrs:{"id":_vm.canvasId}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }